<template lang="pug">
.k-footer.py-2.brand-dark-blue-70
  k-container
    //- Hide the extended footer if the user is not on the homepage and on mobile
    .k-footer__full
      v-row.pb-8
        v-col(md="3").hidden-sm-and-down
          k-icon(color="white" size="55") kintell
        v-col(md="9" sm="12")
          v-row.k-footer__main
            v-col(cols="6" sm="6" md="3")
              h4.small-caps.brand-light-pink--text.mb-6 FIND
              nuxt-link(
                to="/search"
              ) {{ $t('app.pages.search.title') }}
              nuxt-link(
                to="/browse-by-category"
              ) {{ $t('app.pages.browseByCategory.title') }}

            v-col(cols="6" sm="6" md="3")
              h4.small-caps.brand-light-pink--text.mb-6 DISCOVER
              nuxt-link(
                to="/become-an-advisor"
              ) {{ $t('app.pages.becomeAnAdvisor.title') }}
              nuxt-link(to="/pricing") {{ $t('app.pages.pricing.title') }}
              nuxt-link(to="/faq") {{ $t('app.pages.faqs.title') }}
              nuxt-link(to="/articles") {{ $t('app.pages.articles.title') }}


            v-col(cols="6" sm="6" md="3")
              h4.small-caps.brand-light-pink--text.mb-6 Get In Touch
              nuxt-link(to="/get-in-touch") {{ $t('app.pages.getInTouch.title') }}

            v-col(cols="6" sm="6" md="3")
              h4.small-caps.brand-light-pink--text.mb-6 YOUR KINTELL
              template(v-if="userIsAuthenticated")
                nuxt-link(to="/my-kintell/dashboard") Dashboard
                nuxt-link(to="/sign-out") {{ $t('app.pages.signOut.title') }}
              template(v-else)
                nuxt-link(to="/sign-in") {{ $t('app.pages.login.title') }}
                nuxt-link(to="/join-now") {{ $t('app.pages.joinNow.title') }}
      v-divider.pb-8

    v-row(align="center")
      v-col(lg="6" md="8" sm="7" cols="12")
        v-row.white--text
          v-col(lg="4" md="4" sm="5" cols="12")
            v-img(:src="kurfs.birdWithMail" width="192" height="55" contain).mx-auto.mx-sm-0
          v-col(lg="7" md="5" sm="7" cols="12").text-center.text-sm-left
            .paragraph--small.font-weight-bold.mb-4 Feedback
            .paragraph--small
              nuxt-link(to="/get-in-touch").white--text.link--underline Drop us a line
              |  if you have something to share - we’re always looking to improve :)
      v-spacer
      v-col(lg="6" md="4" sm="5" cols="12").text-sm-right.text-xs-center
        // privacy and terms links for non-mobile devices
        .faded--text.white--text.my-7.mt-sm-0
          nuxt-link(to="/privacy").paragraph--small.d-inline-block.white--text {{ $t('app.pages.privacy.title') }}
          span.px-2 |
          nuxt-link(to="/terms-and-conditions").paragraph--small.d-inline-block.white--text {{ $t('app.pages.termsAndConditions.title') }}
          span.paragraph--small.pl-8 &copy; Kintell {{ currentYear }}
        .d-flex.align-items-center.justify-center.justify-sm-end
          a(href="https://www.linkedin.com/company/kintell-com/" target="_blank").brand-dark-blue--text.linkedin.mt-3.px-2
            k-icon(color="brand-grey") linkedin
          //- a(href="https://twitter.com/kintellofficial" target="_blank").brand-dark-blue--text.linkedin.mt-3.px-2
          //-   k-icon(color="brand-grey") twitter
          a(href="https://www.instagram.com/kintell_official/" target="_blank").brand-dark-blue--text.linkedin.mt-3.px-2
            k-icon(color="brand-grey") instagram
          //- a(href="https://www.youtube.com/channel/UCEbUiHCmaZaJq-y_Nq_zPhw/videos" target="_blank").brand-dark-blue--text.linkedin.mt-3.px-2
          //-   k-icon(color="brand-grey") youtube
          a(href="https://www.facebook.com/officialkintell/" target="_blank").mt-3.px-2
            k-icon(color="brand-grey") facebook
</template>

<script>
import {
  ChecksLoggedIn,
  UsesAuthenticatedUser
} from '@/mixins'

export default {
  mixins: [
    ChecksLoggedIn,
    UsesAuthenticatedUser
  ],
  data () {
    return {
      kurfs: {
        birdWithMail: require('~kurfs/bird-with-mail.svg'),
      },
    }
  },
  computed: {
    currentYear () {
      return new Date().getFullYear()
    },
  },
}
</script>


<style lang="scss" scoped>
.k-footer {
  a {
    color: white;
    text-decoration: none;
  }

  &__main {
    a {
      display: block;
      font-size: 16px;
      line-height: 22px;
      margin-bottom: 16px;
    }
  }

  .disabled {
    cursor: not-allowed;
    opacity: .25;
    pointer-events: none;
  }
}
</style>
